import React, { useContext, useEffect } from "react";
import { Grid, Typography, Breadcrumbs, Link } from "@material-ui/core";
import moment from "moment";

import { UseTodayReports } from "./controllers/useTodayReports";
import { UseScalingActions } from "./controllers/useScalingActions";
import { SortCampaigns } from "./controllers/sort";
import { FilterCampaigns } from "./controllers/filter";

import ScalingContext from "../../../context/scaling/ScalingContext";
import ParameterContext from "../../../context/parameters/ParameterContext";
import UserContext from "../../../context/users/UserContext";
import AuthContext from "../../../context/auth/AuthContext";

import ScalingOverview from "./components/Overview";
import CampaignFilter from "./components/CampaignFilter";
import CampaignList from "./components/CampaignList";

const ScalingManagement = () => {
  const {
    setCampaigns,
    campaigns,
    setCampaignsSearched,
    campaigns_searched,
    sort_value,
    search_value,
  } = useContext(ScalingContext);
  const { getCheckoutLanguages } = useContext(ParameterContext);
  const { getUsers } = useContext(UserContext);
  const { user } = useContext(AuthContext);

  // SWR: Get Today's Report and Scaling Actions
  const { REPORTS_LOADING, REPORTS } = UseTodayReports();
  const { SCALING_ACTIONS_LOADING, SCALING_ACTIONS } = UseScalingActions();

  useEffect(() => {
    // Get Languages, Users (Media Buyer)
    getCheckoutLanguages();
    getUsers();
  }, []);

  useEffect(() => {
    if (!REPORTS_LOADING && !SCALING_ACTIONS_LOADING) {
      let campaigns = REPORTS && [...REPORTS];

      if (campaigns && SCALING_ACTIONS) {
        // Function: Filter Campaigns By Media Buyer For Non Admin User Group
        if (user.user_group !== "admin") {
          campaigns = campaigns.filter(
            (campaign) => campaign.media_buyer === user.name
          );
        }

        // Function: Match and Set Scaling Actions into Corresponding Campaign
        campaigns.forEach((campaign) => {
          let actions = SCALING_ACTIONS.filter((scaling) => {
            if (scaling.campaign_id === campaign.campaign_id) {
              // Get Scaling Actions Completed by Today
              if (scaling.status === "COMPLETE") {
                if (moment(scaling.completed_at).isSame(moment(), "day")) {
                  return scaling;
                }
              } else {
                return scaling;
              }
            }
          });

          campaign["actions"] = actions;
        });

        // * Trigger When Data Refetched
        // Function: Sort Campaigns By Sort Value
        if (sort_value) {
          // console.log("Refetch Sort");
          SortCampaigns(campaigns, sort_value);
        }

        // * Trigger When Data Refetched
        // Function: Search Campaigns By Search Value
        if (
          search_value.media_buyer ||
          search_value.scaling_status.length !== 3 ||
          search_value.action_status.length !== 0 ||
          search_value.text
        ) {
          // console.log("Refetch Search", search_value);
          const campaigns_searched = FilterCampaigns(campaigns, search_value);
          setCampaignsSearched(campaigns_searched);
        }

        // Function: Set Campaigns To Context
        setCampaigns(campaigns);
      }
    }
  }, [REPORTS_LOADING, REPORTS, SCALING_ACTIONS_LOADING, SCALING_ACTIONS]);

  useEffect(() => {
    if (sort_value) {
      // * Trigger When Value Changed
      // Function: Sort Campaigns By Sort Value

      if (campaigns_searched) {
        // console.log("Trigger Sort - Campaign Searched");
        SortCampaigns(campaigns_searched, sort_value);
        setCampaignsSearched(campaigns_searched);
      }

      if (campaigns) {
        // console.log("Trigger Sort - Campaign");
        SortCampaigns(campaigns, sort_value);
        setCampaigns(campaigns);
      }
    }
  }, [sort_value]);

  useEffect(() => {
    if (campaigns) {
      // console.log("Trigger Search");

      // * Trigger When Value Changed
      // Function: Search Campaigns By Search Value
      const campaigns_searched = FilterCampaigns(campaigns, search_value);
      setCampaignsSearched(campaigns_searched);
    }
  }, [JSON.stringify(search_value)]);

  return (
    <Grid container spacing={1}>
      {" "}
      {/* Breadcrumbs */}{" "}
      <Grid container justifyContent="flex-start">
        <Grid item xs={12}>
          <Typography variant="h4"> Scaling Management </Typography>{" "}
        </Grid>
        <Grid item xs={12}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link color="inherit"> Scaling Management </Link>{" "}
          </Breadcrumbs>{" "}
        </Grid>{" "}
      </Grid>
      {/* Content */}{" "}
      <Grid
        container
        spacing={2}
        style={{
          marginTop: 5,
        }}
      >
        <ScalingOverview />
        <CampaignFilter />
        <CampaignList />
      </Grid>{" "}
    </Grid>
  );
};

export default ScalingManagement;
